import { put, call } from 'redux-saga/effects';
import axios from '../../../utils/axios';
import {
  getPendingOrderList,
  setTotalPendingOrders,
  getCancelledOrderList,
  setTotalCancelOrders,
  getConfirmOrderList,
  setTotalConfirmOrders,
  getAllOrderList,
  setTotalAllOrders,
  getRejectedList,
  setTotalRejectedOrders,
  startLoading,
  getOrderDetails,
  downLoadOrderReport,
  removeOrderProduct,
  stopLoading,
} from '../../slices/orderList';
import { BASEURL } from '../../../BaseUrl/BaseUrl';
import {
  stopFormLoading,
  startFormLoading,
  hasError,
  getErrorMessage,
  setResponse,
  getDeleteMessage,
  getSuccessMessage,
} from '../../slices/responseStatus';
import { isLogout } from '../../slices/login';

export function* orderListSaga(state) {
  try {
    yield put(hasError(false));
    const { startDate, endDate, page = 1, limit = 20, search = '' } = state;
    yield put(startLoading());
    const modal = localStorage.getItem('orderModal');
    const Token = window.localStorage.getItem('auth-token');
    const searchParam = search ? `&searchText=${search}` : '';
    const pageParams = `&page=${page}&limit=${limit}${searchParam}`;

    if (modal === 'pending') {
      const pendingResponse = yield axios.get(
        `${BASEURL}/userActivities/status?event_type=order&status=Pending&startDate=${startDate}&endDate=${endDate}${pageParams}`,
        { headers: { 'x-auth-token': `${Token}`, 'Cache-Control': 'no-cache' } }
      );
      const pendingOrders = pendingResponse?.data?.data?.UserActivities?.order;
      const total = pendingResponse?.data?.data?.UserActivities?.totalRowsValue;
      yield put(getPendingOrderList(Array.isArray(pendingOrders) ? pendingOrders : []));
      yield put(setTotalPendingOrders(total || 0));
      yield put(downLoadOrderReport(Array.isArray(pendingOrders) ? pendingOrders : []));
    } else if (modal === 'confirm') {
      const confirmResponse = yield axios.get(
        `${BASEURL}/userActivities/status?event_type=order&status=Approved&startDate=${startDate}&endDate=${endDate}${pageParams}`,
        { headers: { 'x-auth-token': `${Token}` } }
      );
      const confirmOrders = confirmResponse?.data?.data?.UserActivities?.order;
      const total = confirmResponse?.data?.data?.UserActivities?.totalRowsValue;
      yield put(getConfirmOrderList(Array.isArray(confirmOrders) ? confirmOrders : []));
      yield put(setTotalConfirmOrders(total || 0));
      yield put(downLoadOrderReport(Array.isArray(confirmOrders) ? confirmOrders : []));
    } else if (modal === 'reject') {
      const rejectedResponse = yield axios.get(
        `${BASEURL}/userActivities/status?event_type=order&status=Rejected&startDate=${startDate}&endDate=${endDate}${pageParams}`,
        { headers: { 'x-auth-token': `${Token}` } }
      );
      const rejectedOrders = rejectedResponse?.data?.data?.UserActivities?.order;
      const total = rejectedResponse?.data?.data?.UserActivities?.totalRowsValue;
      yield put(getRejectedList(Array.isArray(rejectedOrders) ? rejectedOrders : []));
      yield put(setTotalRejectedOrders(total || 0));
      yield put(downLoadOrderReport(Array.isArray(rejectedOrders) ? rejectedOrders : []));
    } else if (modal === 'cancel') {
      const cancelResponse = yield axios.get(
        `${BASEURL}/userActivities/status?event_type=order&status=Cancelled&startDate=${startDate}&endDate=${endDate}${pageParams}`,
        { headers: { 'x-auth-token': `${Token}` } }
      );
      const cancelOrders = cancelResponse?.data?.data?.UserActivities?.order;
      const total = cancelResponse?.data?.data?.UserActivities?.totalRowsValue;
      yield put(getCancelledOrderList(Array.isArray(cancelOrders) ? cancelOrders : []));
      yield put(setTotalCancelOrders(total || 0));
      yield put(downLoadOrderReport(Array.isArray(cancelOrders) ? cancelOrders : []));
    } else if (modal === 'all') {
      const allResponse = yield axios.get(
        `${BASEURL}/userActivities/status?event_type=order&startDate=${startDate}&endDate=${endDate}${pageParams}`,
        { headers: { 'x-auth-token': `${Token}` } }
      );
      const allOrders = allResponse?.data?.data?.UserActivities?.order;
      const total = allResponse?.data?.data?.UserActivities?.totalRowsValue;
      yield put(getAllOrderList(Array.isArray(allOrders) ? allOrders : []));
      yield put(setTotalAllOrders(total || 0));
      yield put(downLoadOrderReport(Array.isArray(allOrders) ? allOrders : []));
      yield put(stopLoading());
    }
  } catch (error) {
    yield put(hasError(true));
    yield put(stopLoading());
    yield put(getErrorMessage(error.error.message));
    if (error.error?.statusCode === 401) {
      yield put(isLogout(true));
    }
  }
}

export function* orderByIdSaga(state) {
  try {
    yield put(hasError(false));
    yield put(startFormLoading());
    const { id } = state;
    const Token = window.localStorage.getItem('auth-token');
    const response = yield axios.get(`${BASEURL}/userActivities/${id}`, {
      headers: {
        'x-auth-token': `${Token}`,
      },
    });
    const orderDetailsResponse = response.data.data.UserActivities;
    yield put(getOrderDetails(orderDetailsResponse === undefined ? [] : orderDetailsResponse));
    yield put(stopFormLoading());
  } catch (error) {
    yield put(hasError(true));
    yield put(getErrorMessage(error.error.message));
  }
}

export function* changeOrderStatusSaga(state) {
  try {
    yield put(hasError(false));
    yield put(startLoading());
    const { id, data } = state;
    const Token = window.localStorage.getItem('auth-token');
    const response = yield axios.put(`${BASEURL}/userActivities/status/${id}`, data, {
      headers: {
        'x-auth-token': `${Token}`,
      },
    });
    yield put(getSuccessMessage(response?.data?.meta?.message || 'Order updated'));
    yield put(setResponse(response.status));
    // Keep details view in sync after any update
    yield call(orderByIdSaga, { id });
    yield put(stopLoading());
  } catch (error) {
    yield put(stopLoading());
    yield put(hasError(true));
    yield put(getErrorMessage(error.error.message));
  }
}

export function* downloadOrderReportSaga(state) {
  try {
    yield put(hasError(false));
    // yield put(startLoading());
    const { startDate, endDate } = state;

    const Token = window.localStorage.getItem('auth-token');

    const response = yield axios.get(
      `${BASEURL}/userActivities/reportDownload?event_type=order&startDate=${startDate}&endDate=${endDate}`,
      {
        headers: {
          'x-auth-token': `${Token}`,
        },
      }
    );
    const datas = response.data.data.UserActivities;
    yield put(downLoadOrderReport(datas === undefined ? [] : datas));
  } catch (error) {
    yield put(hasError(true));
    yield put(getErrorMessage(error.error.message));
  }
}

export function* deleteOrderProductSaga(state) {
  try {
    yield put(hasError(false));
    yield put(startFormLoading());

    const { id, productId } = state;
    const Token = window.localStorage.getItem('auth-token');

    const response = yield axios.delete(`${BASEURL}/userActivities/product/${id}/${productId}`, {
      headers: {
        'x-auth-token': `${Token}`,
      },
    });

    if (response.status === 200) {
      yield put(removeOrderProduct({ productId }));
      yield put(getDeleteMessage(response?.data?.meta?.message || 'Product deleted'));
      // Always refresh after delete so UI stays in sync
      yield call(orderByIdSaga, { id });
    }
    yield put(stopFormLoading());
  } catch (error) {
    yield put(stopFormLoading());
    yield put(hasError(true));
    yield put(getErrorMessage(error?.error?.message || 'Unable to delete product'));
  }
}
